import React from 'react'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';

const ForgotPasswordResetDone = (props) => {
    const {company_details} = props;
  return (
    <Box 
        sx={{
            display:'flex',
            flexDirection:'column',
            height:'100%'
        }}>
            <Box sx={{
                padding:"30px",
                display:'flex',
                flexDirection:'column',
                flex:'1 1 0%'
            }}>
                <Box sx={{
                    display:'flex',
                    flexDirection:'column',
                    justifyContent:'center',
                    alignItems:'center',
                    flex:'1 1 0%'
                }}>
                    <Paper
                    variant="elevation"
                    elevation={1}
                    square={false}
                    sx={{
                        minHeight:{md:'500px',xs:'auto'},
                        height:{md:'500px',xs:'auto'},
                        maxWidth : {md:'900px',xs:'100%'},
                        width: "100%",
                        boxShadow : 'rgba(0, 0, 0, 0.04) 0px 10px 10px 4px',
                        borderRadius : '16px',
                        overflow:'hidden',
                        display : 'flex',
                        flexDirection:{md:'row',xs:'column'},
                        position : 'relative'

                        }}>
                            <Box sx={{
                                width:{md:'50%',xs:'100%'},
                                height:{md:'100%',xs:'8rem'},
                                display:'flex',
                                justifyContent:'center',
                                alignItems : 'center'
                            }}>
                                <img src='/images/forgot-password.png' alt='login.png' style={{width:"100%",height:'100%',objectFit:'cover'}}/>
                            </Box>  
                            <Box sx={{
                                width:{md:'50%',xs:'100%'},
                                padding : {md:'40px',xs:'20px'},
                                display:'flex',
                                justifyContent:'center'
                            }}>
                                <Box sx={{
                                    width:"100%",
                                    display : 'flex',
                                    flexDirection : 'column',
                                    justifyContent : 'center'
                                }}>
                                    <Box sx={{
                                        display:'flex',
                                        flexDirection:'column',
                                        justifyContent:'center',
                                        alignItems:'center',
                                        mt:2,
                                        '& .companyLogo' : {
                                            width : '12rem',
                                            objectFit : 'contain'
                                        }
                                    }}>
                                        <a href='/'><img className='companyLogo' src={company_details?.company_logo} alt='logo.png'/></a>
                                    </Box>
                                    <Typography 
                                    align='center' 
                                    variant='h5' 
                                    sx={{
                                        fontWeight:600,
                                        mt:3
                                    }}
                                    >Welcome to {company_details?.name}
                                    </Typography>
                                    <Box mt={2} sx={{
                                        width:'100%'
                                    }}> 
                                        <Typography 
                                        variant='h6' 
                                        sx={{
                                            fontWeight:600
                                        }}
                                        >Your password reset was successfull
                                        </Typography>
                                        <Typography 
                                        component="p" 
                                        sx={{
                                            fontWeight:400,
                                            mt:1.5
                                        }}
                                        >Your password has been reset. You can login using your new password.
                                        </Typography>
                                        <Box my={1.5} display='flex' sx={{
                                          "&:hover":{
                                            textDecoration : 'underline',
                                            textDecorationColor : '#438FCD'
                                          }
                                        }}>
                                            <Link to="/login" style={{textDecoration:'none',color:'#438FCD'}}>Click here to Login Now</Link>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>  
                    </Paper>
                </Box>
            </Box>
    </Box>
  )
}

export default ForgotPasswordResetDone
